import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  // Login
  {
    path: '/',
    redirect: {
      path: '/companySetting'
    },
  },
  {
    path: '/livefullpage',
    name: 'livefullpage',
    component: () => import('../views/live-fontend/live.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/livefullpage/contact',
    name: 'contact',
    component: () => import('../views/live-fontend/contact.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/signin.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/select-company',
    name: 'select-company',
    component: () => import('../views/login/companySelect.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/enter-password',
    name: 'enter-password',
    component: () => import('../views/login/fillPassword.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/forgetpassword',
    name: 'forgetpassword',
    component: () => import('../views/login/forgetpassword.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import('../views/course/quiz.vue'),
  },
  // Dash board
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   component: () => import('../views/dashboard/dashboard.vue'),
  // },
  // Course
  {
    path: '/related-course',
    name: 'relatedCourse',
    component: () => import('../views/course/template.vue'),
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/course/list.vue'),
  },
  {
    path: '/course-related',
    name: 'course-related',
    component: () => import('../views/course/listRelated.vue'),
  },
  {
    path: '/course/detail',
    name: 'course-detail',
    component: () => import('../views/course/step.vue')
  },
  {
    path: '/course/lecture',
    name: 'course-lecture',
    component: () => import('../views/course/lecture.vue'),
  },
  {
    path: '/course/user',
    name: 'course-user',
    component: () => import('../views/course/users.vue'),
  },
  {
    path: '/course/accessment',
    name: 'course-access',
    component: () => import('../views/course/accessment/accessment.vue'),
  },
  {
    path: '/course-student',
    name: 'my-student',
    component: () => import('../views/course/myStudent.vue'),
  },
  // Live
  {
    path: '/course/report',
    name: 'course-report',
    component: () => import('../views/course/report.vue'),
  },


  // {
  //   path: '/category',
  //   name: 'category',
  //   component: () => import('../views/dataManagement/categoryList.vue'),
  // },
  {
    path: '/category',
    name: 'category',
    component: () => import('../views/dataManagement/category/categoryTab.vue'),
  },
  {
    path: '/skill',
    name: 'skill',
    component: () => import('../views/dataManagement/skill/skillTab.vue'),
  },
  {
    path: '/level',
    name: 'level',
    component: () => import('../views/dataManagement/level/levelTab.vue'),
  },
  {
    path: '/banner',
    name: 'banner',
    component: () => import('../views/banner/banner-list.vue'),
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('../views/notification/notiList.vue'),
  },
  {
    path: '/companySetting',
    name: 'companySetting',
    component: () => import('../views/company/companySetting.vue'),
    // beforeEnter: (to, from, next) => {
    //   // Is the user name not null
    //   if(to.params.name) {
    //     next() // Take you to /chat
    //   } else {
    //       // If params.name is blank or in your case, does not have permission, redirect back to the welcome page
    //     next({ name: 'Welcome' }) 
    //   }
    // }
  },
  // {
  //   path: '/company',
  //   name: 'company',
  //   component: () => import('../views/company/company.vue'),
  // },
  // {
  //   path: '/company/detail',
  //   name: 'company',
  //   component: () => import('../views/company/detail.vue'),
  // },
  {
    path: '/users',
    name: 'user',
    component: () => import('../views/user/userManagement.vue'),
  },
  // {
  //   path: '/account',
  //   name: 'account',
  //   component: () => import('../views/user/accountManagement.vue'),
  // },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('../views/user/registrationManagement.vue'),
  },
  {
    path: '/user-group',
    name: 'user-group',
    component: () => import('../views/user/userGroupManagement.vue'),
  },

  //setting menu
  {
    path: '/setting-menu',
    name: 'setting',
    component: () => import('../views/setting/menu.vue'),
  },
  {
    path: '/banner',
    name: 'banner',
    component: () => import('../views/setting/uploadBanner.vue'),
  },
  {
    path: '/confirmtutor',
    name: 'confirmtutor',
    component: () => import('../views/user/confirmTutor.vue'),
  },

  // register 
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue'),
    meta: {
      layout: 'full-page'
    }
  },
  {
    path: '/register-success',
    name: 'register-success',
    component: () => import('../views/login/registerSuccess.vue'),
    meta: {
      layout: 'full-page'
    }
  },


  // Report
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/report/report.vue'),
  },


  // Live
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/course/live/live.vue'),
  },
  {
    path: '/live-dashboard',
    name: 'live dashboard',
    component: () => import('../views/course/live/liveDashboard.vue'),
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('../views/course/live/chat.vue'),
  },
  {
    path: '/checkName',
    name: 'checkName',
    component: () => import('../views/course/live/checkName.vue'),
  },
  {
    path: '/select-streamkey',
    name: 'select-streamkey',
    meta: {
      layout: 'full-page'
    },
    component: () => import('../views/course/live/liveDialog/selectStreamkey.vue'),
  },
  {
    path: '/setting-live',
    name: 'setting-live',
    meta: {
      layout: 'full-page'
    },
    component: () => import('../views/course/live/liveDialog/settingLive.vue'),
  },
  {
    path: '/dialog-live',
    name: 'dialog-live',
    meta: {
      layout: 'full-page'
    },
    component: () => import('../views/course/live/liveDialog/dialogLive.vue'),
  },
  {
    path: '/tab-info',
    name: 'tab-info',
    meta: {
      layout: 'full-page'
    },
    component: () => import('../views/course/live/tab/info.vue'),
  },
  {
    path: '/tab-url',
    name: 'tab-url',
    meta: {
      layout: 'full-page'
    },
    component: () => import('../views/course/live/tab/URLLink.vue'),
  },

  {
    path: '/course/detail/exam',
    name: 'tab-exam',
    component: () => import('../views/course/lectures/exam/newExamManagement.vue'),
  },

  {
    path: '/dashboard',
    name: 'new-dashboard',
    component: () => import('../views/dashboard/dashboards.vue'),
  }, {
    path: '/dev-report-sell',
    name: 'report-sell',
    component: () => import('../views/reportsellcourse/reportsellcourse.vue'),
  },
  {
    path: '/dev-report-withdraw',
    name: 'report-sell',
    component: () => import('../views/reportwithdraw/reportwithdraw.vue'),
  },

  // Exam
  // {
  //   path: '/dev-ui-exam-single-choice',
  //   name: 'dialog-article',
  //   component: () => import('../views/course/lectures/exam/examSingleAndMultiChoiceUI.vue'),
  // },
  // {
  //   path: '/dev-ui-exam',
  //   name: 'dialog-article',
  //   component: () => import('../views/course/lectures/exam/examUi.vue'),
  // },
  // {
  //   path: '/dev-ui-exam-article',
  //   name: 'dialog-article',
  //   component: () => import('../views/course/lectures/exam/examArticle.vue'),
  // },
  // {
  //   path: '/fill-word',
  //   name: 'fill-word',
  //   component: () => import('../views/course/lectures/exam/fillInTheBlank.vue'),
  // },
  // {
  //   path: '/lecture/exam-management',
  //   name: 'exam-management',
  //   component: () => import('../views/course/lectures/exam/examManagement.vue'),
  // },
  // {
  //   path: '/lecture/exam-matching',
  //   name: 'examMatching',
  //   component: () => import('../views/course/lectures/exam/matching.vue'),
  // },
  // other path
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import('../views/test/accountManagement.vue'),
  // },
  {
    path: '/report-kct',
    name: 'report-kct',
    component: () => import('../views/kct-transformative-personality/report-view.vue'),
  },
  {
    path: '*',
    redirect: {
      path: '/login'
    },
  },
  {
    path: '/step',
    component: () => import('../views/course/step.vue')
  },
  {
    path: '/export-lang',
    component: () => import('../views/test/exportlanguages.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router